import React from 'react';
import { ReactComponent as LoopIcon } from '../../../assets/icons/refresh.svg';
import { ReactComponent as ErrorIcon } from '../../../assets/svg/error_icon.svg';
import { NbButton } from '../../../shared/components/button/Button';
import { Config } from '../../../shared/config/config';
import classes from './GlobalErrorBoundary.module.scss';

export type GlobalErrorBoundaryProps = {
  children: React.ReactNode;
  errorTitle?: string;
  errorText?: string;
  buttonText?: string;
  isFullScreen?: boolean;
};

export let globalErrors: Array<string> = [];

function registerError(event: any) {
  globalErrors.push(`${new Date().toISOString()} - ${typeof event === 'string' ? event : event.message}`);
  if (globalErrors.length > 4) {
    globalErrors.shift();
  }
}
window.addEventListener('error', registerError);

// https://blog.logrocket.com/error-handling-react-error-boundary/
export class GlobalErrorBoundary extends React.Component<
  GlobalErrorBoundaryProps,
  {
    hasError: boolean;
    error: any;
    errorInfo: any;
    isDisplayErrorMessage: boolean;
    retryKey: number;
  }
> {
  constructor(props: GlobalErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      isDisplayErrorMessage: false,
      retryKey: 0,
    };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    registerError(error.stack);
    this.setState({
      hasError: true,
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className={classes.error}>
          <div>
            <ErrorIcon />
          </div>
          <p className={classes.errorTitle}>{this.props.errorTitle || 'Hiba történt a betöltés során'}</p>
          {/*TODO: add id once we have it*/}
          {/*<p className={classes.errorText}>{this.props.errorText || 'Egyedi hibaazonosító:'}</p>*/}
          {/*<p className={classes.errorText}>1234567890</p>*/}

          <NbButton
            variant="text"
            onClick={() => {
              if (this.props.isFullScreen) {
                window.location.reload();
                return;
              }
              this.setState(prev => ({
                hasError: false,
                error: null,
                errorInfo: null,
                isDisplayErrorMessage: false,
                retryKey: prev.retryKey + 1,
              }));
            }}
            startIcon={<LoopIcon />}
            className={classes.errorButton}
          >
            {this.props.buttonText || 'Újratöltés'}
          </NbButton>

          {Config.App.EnableAppDebugger && !this.state.isDisplayErrorMessage && (
            <p
              onClick={() => this.setState({ isDisplayErrorMessage: true })}
              style={{ cursor: 'pointer' }}
            >
              🤯
            </p>
          )}

          {this.state.isDisplayErrorMessage && Config.App.EnableAppDebugger && (
            <div className={classes.errorDev}>
              <p>{this.state.error && this.state.error.toString()}</p>
              <pre>{this.state.errorInfo && this.state.errorInfo.componentStack}</pre>
            </div>
          )}
        </div>
      );
    }

    return <React.Fragment key={this.state.retryKey}>{this.props.children}</React.Fragment>;
  }
}
